import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { InputLabel, FormControl, FormHelperText, Checkbox, ListItemText } from '@mui/material';

interface SelectInputOption {
  label: string;
  value: string;
}

/** Cuántas etiquetas se muestran en el input antes de resumir con "+N". */
const MAX_VISIBLE_LABELS = 2;

export interface SelectMultiInputProps {
  name: string;
  placeholder: string;
  required?: boolean;
  error?: boolean;
  errorInfo?: string;
  options: SelectInputOption[];
  value: string[];
  autoFocus?: boolean;
  disabled?: boolean;
  onChange: (value: string[]) => void;
}

const SelectMultiInput = ({
                       name, placeholder, errorInfo, required = false, error = false, options, value, onChange, autoFocus = false, disabled = false
                     }: SelectMultiInputProps) => {

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    onChange(event.target.value as string[]);
  };

  return (
    <FormControl error={error} required={required} disabled={disabled} fullWidth>
      <InputLabel
        id={`${name}-label`}
        sx={{
          backgroundColor: 'white',
        }}
      >
        {placeholder}
      </InputLabel>
      <Select
        id={name}
        labelId={`${name}-label`}
        variant="outlined"
        value={value}
        onChange={handleChange}
        autoFocus={autoFocus}
        disabled={disabled}
        multiple
        // Sin tope, una lista de cien opciones se despliega a lo largo de toda
        // la pantalla. Se limita la altura y scrollea adentro del propio menú.
        MenuProps={{
          PaperProps: {
            sx: { maxHeight: 320, maxWidth: 360 },
          },
        }}
        renderValue={(selected) => {
          if (selected.length === 0) return '';
          const labels = selected.map(
            (val) => options.find((opt) => opt.value === val)?.label || val
          );
          // Con muchas seleccionadas el texto desborda el input: se muestran
          // las primeras y el resto se resume en un contador.
          if (labels.length > MAX_VISIBLE_LABELS) {
            return `${labels.slice(0, MAX_VISIBLE_LABELS).join(', ')} +${
              labels.length - MAX_VISIBLE_LABELS
            }`;
          }
          return labels.join(', ');
        }}
        displayEmpty
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} dense>
            <Checkbox checked={value.includes(option.value)} size='small' />
            <ListItemText
              primary={option.label}
              primaryTypographyProps={{ noWrap: true }}
            />
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{errorInfo}</FormHelperText>
    </FormControl>
  );
};

export default SelectMultiInput;
